import { useEffect, useState } from 'react';
import { arcadeAudio } from '../platform/audio';
import type { GameMeta, GameResult } from '../platform/types';
import { ErrorBoundary } from './ErrorBoundary';

export function GamePlayer({
  meta,
  onExit,
  onResult,
}: {
  meta: GameMeta;
  onExit: () => void;
  onResult: (r: GameResult) => void;
}) {
  const [muted, setMuted] = useState(arcadeAudio.settings.muted);
  const Game = meta.component;

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'm' || e.key === 'M') {
        setMuted(arcadeAudio.toggleMute());
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <div className="player">
      <header className="player-bar">
        <button type="button" className="ghost" onClick={onExit}>
          ← Lobby
        </button>
        <div className="player-title">
          <span className="eyebrow">{meta.genre}</span>
          <strong>{meta.title}</strong>
        </div>
        <div className="player-actions">
          <button
            type="button"
            className="ghost"
            onClick={() => setMuted(arcadeAudio.toggleMute())}
          >
            {muted ? 'Sound off' : 'Sound on'}
          </button>
        </div>
      </header>
      <div className="stage">
        <ErrorBoundary onReset={onExit}>
          <Game onExit={onExit} onResult={onResult} />
        </ErrorBoundary>
      </div>
      <p className="hint">{meta.controls}</p>
    </div>
  );
}
